import { Box } from "grommet";
// eslint-disable-next-line import/no-webpack-loader-syntax
import ReactMapboxGl, { Layer, Feature, Marker } from "react-mapbox-gl";
import React, { useCallback, useEffect, useRef, useState } from "react";
import StandardColors from "../../../../../../../util/StandardColors";
import "./MapCard.css";
import 'mapbox-gl/dist/mapbox-gl.css';
import MapService from "../../services/MapService";
import { FlightPositionResponse } from "../../../../../../../services/aeroapi/typings/FlightPositionResponse";

function MapCard() {
  const [flightPositions, setFlightPositions] = useState<
    FlightPositionResponse[]
  >([]);

  const Map = ReactMapboxGl({
    accessToken:
      "pk.eyJ1IjoibXVzMm0xNzA1IiwiYSI6ImNsYThiMjlrYzAwdHozcnBncDRjZHhjbXcifQ.FqApaUa-qs065A8A4p51CA",
  });

  const fetchFlightCurrentPositions = useCallback(async () => {
    const positions = await MapService.findCoordinatesOfFlights();
    setFlightPositions(positions);
  }, []);

  useEffect(() => {
    // refresh every 2 minutes
    const intervalHandler = setInterval(fetchFlightCurrentPositions, 120000);

    return () => {
      clearInterval(intervalHandler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box
      elevation="xsmall"
      background={StandardColors.white}
      fill
      round="small"
      direction="column"
      align="center"
    >
      <Map
        style="mapbox://styles/mapbox/streets-v9"
        containerStyle={{
          height: "100%",
          width: "100%",
        }}
        center={[-122.36707, 37.62744]}
      >
        {/* {flightPositions.map((position) => {
          return (
            <Layer
              type="symbol"
              id="marker"
              layout={{ "icon-image": "marker-15" }}
            >
              <Feature
                coordinates={[
                  position.last_position.latitude,
                  position.last_position.longitude,
                ]}
              />
            </Layer>
          );
        })} */}

        <Marker longitude={-122.36707} latitude={37.62744} anchor="bottom">
          <div className="marker temporary-marker">
            <span></span>
          </div>
        </Marker>
      </Map>
    </Box>
  );
}

export default MapCard;
